// extracted by mini-css-extract-plugin
export default {"flag":"InWorkTemplate_flag__MHuwD"};